import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const INSTAGRAM = 'https://www.instagram.com/sa_dropped';
const LINKEDIN  = 'https://www.linkedin.com/in/yusuf-badat-694631293';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="sa-footer-wrapper">
      <div className="sa-footer">

        {/* Brand Section */}
        <div className="footer-brand">
          <div className="footer-logo">SA <span>DROPPED</span></div>
          <p className="footer-bio">
            Specializing in the rarest drops and timeless retros.
            Streetwear is not just trade; it's the art of the work.
          </p>
          <div className="footer-socials">
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="footer-social-link">INSTAGRAM</a>
          </div>
        </div>

        {/* About */}
        <div className="footer-col">
          <h4 className="footer-header">About</h4>
          <div className="footer-links">
            <button className="footer-link" onClick={() => navigate('/about')}>About Us</button>
            <button className="footer-link" onClick={() => { navigate('/'); setTimeout(() => document.querySelector('.featured')?.scrollIntoView({ behavior: 'smooth' }), 100); }}>Features</button>
            <button className="footer-link" onClick={() => navigate('/blog')}>News</button>
          </div>
        </div>

        {/* Company */}
        <div className="footer-col">
          <h4 className="footer-header">Company</h4>
          <div className="footer-links">
            <button className="footer-link" onClick={() => { navigate('/'); setTimeout(() => document.querySelector('.faq')?.scrollIntoView({ behavior: 'smooth' }), 100); }}>FAQs</button>
            <button className="footer-link" onClick={() => navigate('/blog')}>Blogs</button>
          </div>
        </div>

        {/* Support */}
        <div className="footer-col">
          <h4 className="footer-header">Support</h4>
          <div className="footer-links">
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="footer-link">Support Center</a>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="footer-link">Feedback</a>
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="footer-link">Contact Us</a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <div className="footer-line"></div>
        <div className="footer-credits">
          <p>© 2026 SA DROPPED. ALL RIGHTS RESERVED.</p>
          <a href={LINKEDIN} target="_blank" rel="noreferrer" className="dev-credit">
            WEBSITE MADE BY <span>YUSUF BADAT</span>
          </a>
        </div>
      </div>
    </footer>
  );
}